import React, { useState, useEffect, useRef } from "react";
import { NavLink, useParams } from "react-router-dom";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    fontSize: 10,
    padding: 10,
    paddingBottom: 40, // Space for page number
    color: "#000000",
  },
  viewer: {
    width: "100%",
    height: "90vh",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "#666666",
  },
  invoiceTitle: {
    fontSize: 22,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 2,
    padding: 6,
    backgroundColor: "#ffffff",
  },
  subtitle: {
    fontSize: 9,
    textAlign: "center",
    marginBottom: 2,
  },
  recipient: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 8,
  },
  irnSection: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    minHeight: 80,
  },
  irnText: {
    width: "70%",
    padding: 6,
    justifyContent: "space-between",
  },
  irnRow: {
    flexDirection: "row",
    marginBottom: 2,
  },
  irnLabel: {
    width: "25%",
    fontWeight: "bold",
    fontSize: 8,
  },
  irnValue: {
    width: "75%",
    fontSize: 8,
    wordWrap: "break-word",
  },
  irnFooter: {
    textAlign: "center",
    fontSize: 9,
    fontWeight: "bold",
    marginTop: 6,
  },
  qrPlaceholder: {
    width: "30%",
    backgroundColor: "#f0f0f0",
    alignItems: "center",
    justifyContent: "center",
    borderLeftWidth: 1,
    borderLeftColor: "#000000",
    borderLeftStyle: "solid",
  },
  qrText: {
    fontSize: 8,
    textAlign: "center",
    color: "#666",
  },
  mainHeaderSection: {
    flexDirection: "row",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
  },
  leftHalfSection: {
    width: "50%",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    backgroundColor: "#ffffff",
  },
  logoCompanySection: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    backgroundColor: "#ffffff",
  },
  logoSection: {
    width: "30%",
    padding: 6,
    alignItems: "center",
    justifyContent: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
  },
  logoImage: {
    width: 50,
    height: 50,
  },
  logoPlaceholder: {
    width: 50,
    height: 50,
    backgroundColor: "#f8f8f8",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "#ddd",
    borderStyle: "solid",
  },
  logoText: {
    fontSize: 7,
    color: "#666",
    textAlign: "center",
  },
  companySection: {
    width: "70%",
    backgroundColor: "#ffffff",
  },
  companyName: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "left",
    padding: 6,
    backgroundColor: "#f8f8f8",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  companyDetails: {
    fontSize: 9,
    lineHeight: 1.3,
    padding: 6,
  },
  companyDetailLine: {
    marginBottom: 2,
  },
  buyerSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    backgroundColor: "#ffffff",
  },
  siteLocationSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    backgroundColor: "#ffffff",
  },
  buyerHeader: {
    backgroundColor: "#f5f5f5",
    padding: 6,
    fontSize: 11,
    fontWeight: "bold",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    textAlign: "left",
  },
  buyerContent: {
    padding: 8,
    fontSize: 9,
    lineHeight: 1.4,
  },
  buyerLine: {
    marginBottom: 2,
  },
  boldText: {
    fontWeight: "bold",
  },
  rightHalfSection: {
    width: "50%",
    backgroundColor: "#ffffff",
  },
  invoiceDetailsBlock: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    padding: 6,
  },
  detailRow: {
    flexDirection: "row",
    marginBottom: 2,
  },
  detailLabel: {
    width: "50%",
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "left",
  },
  detailValue: {
    width: "50%",
    fontSize: 9,
    textAlign: "left",
  },
  remarksSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    padding: 8,
    backgroundColor: "#fffbf0",
  },
  remarksHeader: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 4,
  },
  remarksText: {
    fontSize: 10,
    lineHeight: 1.3,
  },
  servicesTable: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    alignItems: "stretch",
  },
  headerCellContainer: {
    justifyContent: "center",
    alignItems: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    padding: 4,
  },
  headerCellText: {
    fontWeight: "bold",
    fontSize: 9,
    textAlign: "center",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    backgroundColor: "#ffffff",
    alignItems: "stretch",
  },
  tableCellContainer: {
    justifyContent: "flex-start",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    padding: 4,
  },
  tableCellText: {
    fontSize: 8,
  },
  tableCellLeft: {
    textAlign: "left",
  },
  tableCellRight: {
    textAlign: "right",
  },
  serviceDescriptionText: {
    textAlign: "left",
    lineHeight: 1.3,
  },
  dateRangeText: {
    fontSize: 7,
    color: "#666",
    marginTop: 2,
    fontStyle: "italic",
  },
  itemRemarksText: {
    fontSize: 7,
    color: "#666",
    marginTop: 4,
    fontStyle: "italic",
  },
  totalRow: {
    flexDirection: "row",
    backgroundColor: "#e6e6e6",
    borderBottomWidth: 0,
    alignItems: "stretch",
  },
  totalCellContainer: {
    justifyContent: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    padding: 4,
  },
  totalCellText: {
    fontWeight: "bold",
    fontSize: 10,
  },
  hsnTable: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
  },
  hsnHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    alignItems: "stretch",
  },
  hsnRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    backgroundColor: "#ffffff",
    alignItems: "stretch",
  },
  hsnTotalRow: {
    flexDirection: "row",
    backgroundColor: "#e6e6e6",
    fontWeight: "bold",
    alignItems: "stretch",
  },
  hsnCellContainer: {
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    justifyContent: "center",
    alignItems: "center",
  },
  hsnCellText: {
    fontSize: 9,
    textAlign: "center",
  },
  hsnCellTextRight: {
    textAlign: "right",
  },
  hsnCellContainerNoBorder: {
    borderRightWidth: 0,
  },
  amountSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 3,
    padding: 8,
    backgroundColor: "#f9f9f9",
  },
  amountHeader: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 4,
  },
  amountValue: {
    fontSize: 10,
    lineHeight: 1.3,
  },
  bottomSection: {
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    marginBottom: 4,
  },
  bankSection: {
    backgroundColor: "#ffffff",
  },
  bankHeader: {
    backgroundColor: "#f5f5f5",
    padding: 6,
    fontSize: 11,
    fontWeight: "bold",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  bankRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
  },
  bankRowNoBorder: {
    flexDirection: "row",
  },
  bankLabel: {
    width: "45%",
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    backgroundColor: "#f9f9f9",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    textAlign: "left",
  },
  bankValue: {
    width: "55%",
    padding: 5,
    fontSize: 10,
    textAlign: "left",
  },
  gstNote: {
    fontSize: 9,
    padding: 8,
    lineHeight: 1.3,
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 6,
    marginBottom: 10,
  },
  signatureBox: {
    width: "40%",
    borderWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
    padding: 8,
    backgroundColor: "#ffffff",
    justifyContent: "space-between",
    minHeight: 60,
  },
  signatureText: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "right",
    marginBottom: 8,
  },
  footerText: {
    textAlign: "center",
    marginTop: 8,
    marginBottom: 15,
    fontSize: 9,
    fontStyle: "italic",
    color: "#666666",
  },
  errorText: {
    textAlign: "center",
    marginTop: 100,
    fontSize: 12,
    color: "#ff0000",
  },
});

const numberToWords = (num) => {
  if (!num || num === 0) return "Zero";

  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' ' + convertLessThanThousand(n % 100) : '');
  };

  const n = Math.floor(num);
  if (n === 0) return "Zero";

  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const remainder = n % 1000;

  let result = '';
  if (crore) result += convertLessThanThousand(crore) + ' Crore ';
  if (lakh) result += convertLessThanThousand(lakh) + (lakh > 1 ? ' Lacs ' : ' Lac ');
  if (thousand) result += convertLessThanThousand(thousand) + ' Thousand ';
  if (remainder) result += convertLessThanThousand(remainder);

  return result.trim();
};

const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

const getUnitName = (unitId, units) => {
  if (!unitId || !units) return '';
  const unit = units.find(u => u.id === String(unitId));
  return unit ? unit.value : unitId;
};

const formatAssetDetails = (assetName, assets) => {
  if (!assetName || !assets) return assetName || '';
  
  const asset = assets.find(a => a.name === assetName);
  if (!asset) return assetName;
  
  const parts = [asset.name];
  
  if (asset.serial_number) {
    parts.push(asset.serial_number);
  }
  
  if (asset.registration_number) {
    parts.push(asset.registration_number);
  }
  
  return parts.join(' | ');
};

// Header component - NOT FIXED, will only appear on first page
const InvoiceHeader = ({ invoice_master, company, customers, projects, work_order_master, logoSource, formatDate }) => {
  const placeOfSupply = projects?.state || customers?.state_name || "MAHARASHTRA";
  const stateCode = customers?.state_id || "27";

  return (
    <>
      <Text style={styles.invoiceTitle}>TAX INVOICE</Text>
      <Text style={styles.subtitle}>(As per Rule 46 of CGST Rules,2017 & Section 31 of CGST Act,2017)</Text>
      <Text style={styles.recipient}>Original for Recipient</Text>

      <View style={styles.mainHeaderSection}>
        <View style={styles.leftHalfSection}>
          <View style={styles.logoCompanySection}>
            <View style={styles.logoSection}>
              {logoSource ? (
                <Image 
                  style={styles.logoImage} 
                  src={logoSource}
                  cache={false}
                />
              ) : (
                <View style={styles.logoPlaceholder}>
                  <Text style={styles.logoText}>Company{"\n"}Logo</Text>
                </View>
              )}
            </View>
            <View style={styles.companySection}>
              <Text style={styles.companyName}>
                {company.company_name || company.companyName || "PUNE LOGITECH SERVICES PRIVATE LIMITED"}
              </Text>
              <View style={styles.companyDetails}>
                {company.address && <Text style={styles.companyDetailLine}>{company.address}</Text>}
                {company.cin && <Text style={styles.companyDetailLine}>CIN: {company.cin}</Text>}
                {(company.udyam_no || company.udyamNo) && <Text style={styles.companyDetailLine}>UDYAM No. {company.udyam_no || company.udyamNo}</Text>}
                {company.gstin || company.gstNumber || company.gst_number ? (
                  <Text style={styles.companyDetailLine}>
                    GSTIN/UIN: {company.gstin || company.gstNumber || company.gst_number}
                  </Text>
                ) : null}
                {(company.state_name || company.stateName || company.state_code || company.stateCode) && (
                  <Text style={styles.companyDetailLine}>
                    State Name: {company.state_name || company.stateName || "Maharashtra"}, Code: {company.state_code || company.stateCode || "27"}
                  </Text>
                )}
                {(company.email_address || company.emailAddress) && (
                  <Text style={styles.companyDetailLine}>
                    E-Mail: {company.email_address || company.emailAddress}
                  </Text>
                )}
              </View>
            </View>
          </View>
        </View>

        <View style={styles.rightHalfSection}>
          <View style={styles.invoiceDetailsBlock}>
            {invoice_master.doc_no && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Invoice No.</Text>
                <Text style={styles.detailValue}>{invoice_master.doc_no}</Text>
              </View>
            )}
            {invoice_master.inv_date && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Dated</Text>
                <Text style={styles.detailValue}>{formatDate(invoice_master.inv_date)}</Text>
              </View>
            )}
            {(invoice_master.start_date && invoice_master.end_date) && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Reference No. & Date</Text>
                <Text style={styles.detailValue}>
                  Period: {formatDate(invoice_master.start_date)} to {formatDate(invoice_master.end_date)}
                </Text>
              </View>
            )}
            {(work_order_master?.wo_no || customers?.po_no) && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Buyer's Order No.</Text>
                <Text style={styles.detailValue}>{work_order_master?.wo_no || customers?.po_no}</Text>
              </View>
            )}
            {work_order_master?.wo_date && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Dated</Text>
                <Text style={styles.detailValue}>{formatDate(work_order_master.wo_date)}</Text>
              </View>
            )}
            {invoice_master.dispatch_doc_no && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Dispatch Doc No.</Text>
                <Text style={styles.detailValue}>{invoice_master.dispatch_doc_no}</Text>
              </View>
            )}
            {invoice_master.delivery_note_date && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Delivery Note Date</Text>
                <Text style={styles.detailValue}>{formatDate(invoice_master.delivery_note_date)}</Text>
              </View>
            )}
            {invoice_master.dispatched_through && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Dispatched through</Text>
                <Text style={styles.detailValue}>{invoice_master.dispatched_through}</Text>
              </View>
            )}
            {projects?.city && (
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Destination</Text>
                <Text style={styles.detailValue}>Site: {projects.city}</Text>
              </View>
            )}
          </View>
        </View>
      </View>

      <View style={{ flexDirection: "row" }}>
        <View style={[styles.buyerSection, { width: "50%", marginRight: 3 }]}>
          <Text style={styles.buyerHeader}>Details of Receiver (Billed To)</Text>
          <View style={styles.buyerContent}>
            {customers?.name && <Text style={[styles.buyerLine, styles.boldText]}>{customers.name}</Text>}
            {customers?.address && <Text style={styles.buyerLine}>{customers.address}</Text>}
            {customers?.project_code && (
              <Text style={styles.buyerLine}>Project Code: {customers.project_code}</Text>
            )}
            <Text style={styles.buyerLine}>
              GSTIN/UIN: {customers?.gst_no || "Unregistered GST"}
            </Text>
            {(customers?.state_name || customers?.state_id) && (
              <Text style={styles.buyerLine}>
                State Name: {customers?.state_name}, Code: {customers?.state_id}
              </Text>
            )}
            {invoice_master.kind_attn && (
              <Text style={styles.buyerLine}>Kind Attention: {invoice_master.kind_attn}</Text>
            )}
          </View>
        </View>

        <View style={[styles.siteLocationSection, { width: "50%" }]}>
          <Text style={styles.buyerHeader}>Details of Site Location</Text>
          <View style={styles.buyerContent}>
            {(projects?.name || customers?.name) && (
              <Text style={[styles.buyerLine, styles.boldText]}>
                {projects?.name || customers?.name}
              </Text>
            )}
            {(projects?.address || customers?.address) && (
              <Text style={styles.buyerLine}>{projects?.address || customers?.address}</Text>
            )}
            <Text style={styles.buyerLine}>
              Place of Supply: {placeOfSupply} State Code: {stateCode}
            </Text>
          </View>
        </View>
      </View>
    </>
  );
};

export const InvoiceDocument = ({ allData, company, workOrderTrans, workTypes, fileName, units, assets }) => {
  if (!allData || !company || !allData.invoice_master) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Text style={styles.errorText}>
            Error: Unable to load invoice data. Please try again.
          </Text>
        </Page>
      </Document>
    );
  }

  const {
    invoice_master = {},
    invoice_tran = [],
    customers = {},
    projects = {},
    work_order_master = {},
  } = allData;

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      const d = new Date(date);
      if (isNaN(d.getTime())) return "N/A";
      const day = d.getDate().toString().padStart(2, '0');
      const month = d.toLocaleString('default', { month: 'short' });
      const year = d.getFullYear() % 100;
      return `${day}-${month}-${year}`;
    } catch {
      return "N/A";
    }
  };

  const taxRate = 18;
  const cgstSgstRate = taxRate / 2;

  const totalTaxable = invoice_tran.reduce((acc, item) => acc + (parseFloat(item.taxable_amount) || 0), 0);
  const totCgst = invoice_tran.reduce((acc, item) => acc + (parseFloat(item.cgst_amount) || 0), 0);
  const totSgst = invoice_tran.reduce((acc, item) => acc + (parseFloat(item.sgst_amount) || 0), 0);
  const totIgst = invoice_tran.reduce((acc, item) => acc + (parseFloat(item.igst_amount) || 0), 0);

  const computedAmount = totalTaxable + totCgst + totSgst + totIgst;
  const grandTotal = Math.round(computedAmount);
  const amountInWords = `${numberToWords(grandTotal)} Only`;

  const enhancedInvoiceTran = invoice_tran.map(item => {
    const taxable = parseFloat(item.taxable_amount) || 0;
    const cgstAmt = parseFloat(item.cgst_amount) || 0;
    const sgstAmt = parseFloat(item.sgst_amount) || 0;
    const igstAmt = parseFloat(item.igst_amount) || 0;
    const itemTotal = taxable + cgstAmt + sgstAmt + igstAmt;
    return {
      ...item,
      cgstAmt,
      sgstAmt,
      igstAmt,
      itemTotal,
    };
  });

  // Group HSN codes with their totals
  const hsnGroups = invoice_tran.reduce((acc, item) => {
    const hsnCode = item.hsn_code || '997319';
    if (!acc[hsnCode]) {
      acc[hsnCode] = {
        taxable: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
      };
    }
    acc[hsnCode].taxable += parseFloat(item.taxable_amount) || 0;
    acc[hsnCode].cgst += parseFloat(item.cgst_amount) || 0;
    acc[hsnCode].sgst += parseFloat(item.sgst_amount) || 0;
    acc[hsnCode].igst += parseFloat(item.igst_amount) || 0;
    return acc;
  }, {});

  let logoSource = null;
  const logoUrl = company?.logo_url || company?.companyLogoUrl;
  const logoData = company?.logo_url || company?.companyLogo;
  
  if (logoUrl) {
    logoSource = logoUrl;
  } else if (logoData) {
    try {
      if (typeof logoData === 'string' && logoData.startsWith('data:image')) {
        logoSource = logoData;
      } else if (typeof logoData === 'string' && logoData.length > 100) {
        logoSource = `data:image/png;base64,${logoData}`;
      } else if (logoData instanceof ArrayBuffer || logoData?.type === 'Buffer') {
        const base64 = arrayBufferToBase64(logoData);
        logoSource = `data:image/png;base64,${base64}`;
      }
    } catch (error) {
      console.error("Error processing logo:", error);
      logoSource = null;
    }
  }

  return (
    <Document title={fileName}>
      <Page size="A4" style={styles.page}>
        {/* Header - Only on first page, NOT FIXED */}
        <InvoiceHeader 
          invoice_master={invoice_master}
          company={company}
          customers={customers}
          projects={projects}
          work_order_master={work_order_master}
          logoSource={logoSource}
          formatDate={formatDate}
        />

        {/* IRN Section */}
        {invoice_master.irn && (
          <View style={styles.irnSection} wrap={false}>
            <View style={styles.irnText}>
              <View style={styles.irnRow}>
                <Text style={styles.irnLabel}>IRN :</Text>
                <Text style={styles.irnValue}>{invoice_master.irn || "N/A"}</Text>
              </View>
              <View style={styles.irnRow}>
                <Text style={styles.irnLabel}>Ack No. :</Text>
                <Text style={styles.irnValue}>{invoice_master.ack_no || "N/A"}</Text>
              </View>
              <View style={styles.irnRow}>
                <Text style={styles.irnLabel}>Ack Date :</Text>
                <Text style={styles.irnValue}>{formatDate(invoice_master.ack_date)}</Text>
              </View>
              <Text style={styles.irnFooter}>e-Invoice</Text>
            </View>
            <View style={styles.qrPlaceholder}>
              <Text style={styles.qrText}>QR Code{"\n"}Placeholder</Text>
            </View>
          </View>
        )}

        {/* Remarks Section */}
        {invoice_master.inv_rem && (
          <View style={styles.remarksSection} wrap={false}>
            <Text style={styles.remarksText}>
              <Text style={styles.remarksHeader}>Remarks: </Text>
              {invoice_master.inv_rem}
            </Text>
          </View>
        )}

        {/* Services Table */}
        <View style={styles.servicesTable}>
          <View style={styles.tableHeader}>
            <View style={[styles.headerCellContainer, { width: "22%" }]}>
              <Text style={styles.headerCellText}>Asset Name with Model, Make,{"\n"}Registration Number and Serial Number</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "7%" }]}>
              <Text style={styles.headerCellText}>HSN Code</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "9%" }]}>
              <Text style={styles.headerCellText}>Charges</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "13%" }]}>
              <Text style={styles.headerCellText}>Quantity{"\n"}Unit{"\n"}Rate{"\n"}Amount</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "11%" }]}>
              <Text style={styles.headerCellText}>CGST{"\n"}%{"\n"}Amount</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "11%" }]}>
              <Text style={styles.headerCellText}>SGST{"\n"}%{"\n"}Amount</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "9%" }]}>
              <Text style={styles.headerCellText}>IGST{"\n"}%{"\n"}Amount</Text>
            </View>
            <View style={[styles.headerCellContainer, { width: "18%", borderRightWidth: 0 }]}>
              <Text style={styles.headerCellText}>Total Amount</Text>
            </View>
          </View>

          {enhancedInvoiceTran.slice().reverse().map((item, index) => {
            const assetDetails = formatAssetDetails(item.asset_name, assets);
            const unitName = getUnitName(item.unit, units);
            const invoiceFor = item.invoice_for || '';
            
            const startDate = formatDate(item.start_date);
            const endDate = formatDate(item.end_date);
            const dateRange = `Period: ${startDate} to ${endDate}`;
            
            const description = `${assetDetails}${item.asset_code ? ` ${item.asset_code}` : ''}\n${invoiceFor}`;
            
            const chargesText = item.taxable_amount.toLocaleString('en-IN', { 
              minimumFractionDigits: 2, 
              maximumFractionDigits: 2 
            });
            
            const quantityUnitRateAmount = `${item.quantity ? item.quantity.toFixed(3) : ''}\n${unitName || ''}\n${item.rate ? item.rate.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}\n${item.taxable_amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            
            const cgstText = item.cgstAmt !== 0 && item.cgstAmt !== null ? `${cgstSgstRate}%\n${item.cgstAmt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
            const sgstText = item.sgstAmt !== 0 && item.sgstAmt !== null ? `${cgstSgstRate}%\n${item.sgstAmt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
            const igstText = item.igstAmt !== 0 && item.igstAmt !== null ? `${taxRate}%\n${item.igstAmt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
            const totalText = `${item.itemTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

            return (
              <View style={styles.tableRow} key={index}>
                <View style={[styles.tableCellContainer, { width: "22%" }]}>
                  <Text style={[styles.tableCellText, styles.serviceDescriptionText]}>
                    {description}
                  </Text>
                  <Text style={styles.dateRangeText}>
                    {dateRange}
                  </Text>
                  {item.remarks && (
                    <Text style={styles.itemRemarksText}>
                      Remarks: {item.remarks}
                    </Text>
                  )}
                </View>
                <View style={[styles.tableCellContainer, { width: "7%" }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>
                    {item.hsn_code || '997319'}
                  </Text>
                </View>
                <View style={[styles.tableCellContainer, { width: "9%" }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>{chargesText}</Text>
                </View>
                <View style={[styles.tableCellContainer, { width: "13%" }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>{quantityUnitRateAmount}</Text>
                </View>
                <View style={[styles.tableCellContainer, { width: "11%" }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>{cgstText}</Text>
                </View>
                <View style={[styles.tableCellContainer, { width: "11%" }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>{sgstText}</Text>
                </View>
                <View style={[styles.tableCellContainer, { width: "9%" }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>{igstText}</Text>
                </View>
                <View style={[styles.tableCellContainer, { width: "18%", borderRightWidth: 0 }]}>
                  <Text style={[styles.tableCellText, styles.tableCellRight]}>{totalText}</Text>
                </View>
              </View>
            );
          })}

          <View style={styles.totalRow}>
            <View style={[styles.totalCellContainer, { width: "22%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellLeft]}>Total Rs. :</Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "7%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>-</Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "9%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>-</Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "13%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>
                {totalTaxable.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "11%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>{totCgst !== 0 ? totCgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}</Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "11%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>{totSgst !== 0 ? totSgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}</Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "9%" }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>{totIgst !== 0 ? totIgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}</Text>
            </View>
            <View style={[styles.totalCellContainer, { width: "18%", borderRightWidth: 0 }]}>
              <Text style={[styles.totalCellText, styles.tableCellRight]}>{grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
            </View>
          </View>
        </View>

        {/* Amount in Words - Keep together */}
        <View style={styles.amountSection} wrap={false}>
          <Text style={styles.amountHeader}>Amount in Words:</Text>
          <Text style={styles.amountValue}>Rupees {amountInWords}</Text>
        </View>

        {/* HSN Table - Keep together */}
        <View style={styles.hsnTable} wrap={false}>
          <View style={styles.hsnHeader}>
            <View style={[styles.hsnCellContainer, { width: "15%" }]}>
              <Text style={styles.hsnCellText}>HSN/SAC</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "17%" }]}>
              <Text style={styles.hsnCellText}>Taxable{"\n"}Value</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "10%" }]}>
              <Text style={styles.hsnCellText}>CGST{"\n"}Rate</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "12%" }]}>
              <Text style={styles.hsnCellText}>CGST{"\n"}Amount</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "10%" }]}>
              <Text style={styles.hsnCellText}>SGST{"\n"}Rate</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "12%" }]}>
              <Text style={styles.hsnCellText}>SGST{"\n"}Amount</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "10%" }]}>
              <Text style={styles.hsnCellText}>IGST{"\n"}Rate</Text>
            </View>
            <View style={[styles.hsnCellContainer, styles.hsnCellContainerNoBorder, { width: "14%" }]}>
              <Text style={styles.hsnCellText}>IGST{"\n"}Amount</Text>
            </View>
          </View>

          {Object.entries(hsnGroups).map(([hsnCode, values], index) => (
            <View style={styles.hsnRow} key={index}>
              <View style={[styles.hsnCellContainer, { width: "15%" }]}>
                <Text style={styles.hsnCellText}>{hsnCode}</Text>
              </View>
              <View style={[styles.hsnCellContainer, { width: "17%" }]}>
                <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                  {values.taxable.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </Text>
              </View>
              <View style={[styles.hsnCellContainer, { width: "10%" }]}>
                <Text style={styles.hsnCellText}>{values.cgst !== 0 ? `${cgstSgstRate}%` : "-"}</Text>
              </View>
              <View style={[styles.hsnCellContainer, { width: "12%" }]}>
                <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                  {values.cgst !== 0 ? values.cgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
                </Text>
              </View>
              <View style={[styles.hsnCellContainer, { width: "10%" }]}>
                <Text style={styles.hsnCellText}>{values.sgst !== 0 ? `${cgstSgstRate}%` : "-"}</Text>
              </View>
              <View style={[styles.hsnCellContainer, { width: "12%" }]}>
                <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                  {values.sgst !== 0 ? values.sgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
                </Text>
              </View>
              <View style={[styles.hsnCellContainer, { width: "10%" }]}>
                <Text style={styles.hsnCellText}>{values.igst !== 0 ? `${taxRate}%` : "-"}</Text>
              </View>
              <View style={[styles.hsnCellContainer, styles.hsnCellContainerNoBorder, { width: "14%" }]}>
                <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                  {values.igst !== 0 ? values.igst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
                </Text>
              </View>
            </View>
          ))}

          <View style={styles.hsnTotalRow}>
            <View style={[styles.hsnCellContainer, { width: "15%" }]}>
              <Text style={styles.hsnCellText}>Total</Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "17%" }]}>
              <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                {totalTaxable.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "10%" }]}>
              <Text style={styles.hsnCellText}></Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "12%" }]}>
              <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                {totCgst !== 0 ? totCgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
              </Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "10%" }]}>
              <Text style={styles.hsnCellText}></Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "12%" }]}>
              <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                {totSgst !== 0 ? totSgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
              </Text>
            </View>
            <View style={[styles.hsnCellContainer, { width: "10%" }]}>
              <Text style={styles.hsnCellText}></Text>
            </View>
            <View style={[styles.hsnCellContainer, styles.hsnCellContainerNoBorder, { width: "14%" }]}>
              <Text style={[styles.hsnCellText, styles.hsnCellTextRight]}>
                {totIgst !== 0 ? totIgst.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-"}
              </Text>
            </View>
          </View>
        </View>

        {/* Bank Details and Signature - Keep together on same page */}
        <View wrap={false}>
          <View style={styles.bottomSection}>
            <View style={styles.bankSection}>
              <Text style={styles.bankHeader}>Bank Details</Text>
              <View style={styles.bankRow}>
                <Text style={styles.bankLabel}>A/c Holder's Name:</Text>
                <Text style={styles.bankValue}>
                  {company.company_name || company.companyName || "PUNE LOGITECH SERVICES PRIVATE LIMITED"}
                </Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={styles.bankLabel}>Bank Name:</Text>
                <Text style={styles.bankValue}>{company.bank_name || company.bankName || "Kotak Mahindra Bank Ltd. -C/A"}</Text>
              </View>
              <View style={styles.bankRow}>
                <Text style={styles.bankLabel}>A/c No.:</Text>
                <Text style={styles.bankValue}>{company.account_no || company.accountNo || "8799 900 724"}</Text>
              </View>
              <View style={styles.bankRowNoBorder}>
                <Text style={styles.bankLabel}>Branch & IFS Code:</Text>
                <Text style={styles.bankValue}>
                  {company.branch_ifs || company.branchIfs || "Hinjewadi Phase -1, Pune & KKBK0001819"}
                </Text>
              </View>
              <Text style={styles.gstNote}>
                As per GST rules 46 referred in section 31 of GST Act 2017 on "Tax Invoice, Credit and Debit Notes" {company.company_name || company.companyName || "PUNE LOGITECH SERVICES PRIVATE LIMITED"} may representative with digital signature.
              </Text>
            </View>
          </View>

          <View style={styles.signatureSection}>
            <View style={styles.signatureBox}>
              <Text style={styles.signatureText}>
                for {company.company_name || "PUNE LOGITECH SERVICES PRIVATE LIMITED"}
              </Text>
              <Text style={styles.signatureText}>Authorised Signatory</Text>
            </View>
          </View>

          <Text style={styles.footerText}>
            This is a Computer Generated Invoice
          </Text>
        </View>

        {/* Page Number - Fixed at bottom */}
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `Page ${pageNumber} of ${totalPages}`
        )} fixed />
      </Page>
    </Document>
  );
};

export default function InvoicePrint() {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const [allData, setAllData] = useState(null);
  const [workOrderTrans, setWorkOrderTrans] = useState(null);
  const [workTypes, setWorkTypes] = useState(null);
  const [units, setUnits] = useState([]);
  const [assets, setAssets] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("zTaskAuthToken");
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!token) {
        setError("Authentication token is missing. Please log in again.");
        setLoading(false);
        return;
      }

      abortControllerRef.current = new AbortController();
      const signal = abortControllerRef.current.signal;

      const fetchWithRetry = async (url, options, retries = 3, delay = 1000) => {
        let lastError;
        for (let i = 0; i < retries; i++) {
          try {
            const response = await fetch(url, { ...options, signal });
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return await response.json();
          } catch (err) {
            if (err.name === 'AbortError') {
              throw err;
            }
            lastError = err;
            if (i < retries - 1) {
              await new Promise(resolve => setTimeout(resolve, delay));
            }
          }
        }
        throw lastError;
      };

      try {
        setError(null);
        setLoading(true);

        let companyInfo = {
          companyName: "CHETAK CRANES & COMPANY",
          company_name: "CHETAK CRANES & COMPANY",
          address:
            "THE EPICENTER, 503, Waman Tukaram Patil Marg, Borla, Mark, Chembur, Mumbai, Maharashtra 400088.",
          gstNumber: "19AARFC6430H1Z6",
          gstin: "19AARFC6430H1Z6",
          emailAddress: "sagar.tayade@chetakcranes.com",
        };
        try {
          const companyData = await fetchWithRetry(
            `${process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL}/api/get-company`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          companyInfo = companyData.message?.[0] || companyInfo;
        } catch (companyErr) {
          console.warn("get-company failed; using fallback branding", companyErr);
        }
        setCompany(companyInfo);

        const unitsData = await fetchWithRetry(
          `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/common_master/unit`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUnits(unitsData || []);

        const assetsData = await fetchWithRetry(
          `${process.env.REACT_APP_ASSET_SERVICE_BASE_URL}/api/assets/`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAssets(assetsData || []);

        const invoiceData = await fetchWithRetry(
          `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/invoice/api/invoices/${id}/report`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (invoiceData.error) {
          setError(invoiceData.error);
          setLoading(false);
          return;
        }

        setAllData(invoiceData);

        if (invoiceData.invoice_master?.wo_id) {
          const woId = invoiceData.invoice_master.wo_id;
          const startDate = invoiceData.invoice_master.start_date;
          const endDate = invoiceData.invoice_master.end_date;

          try {
            const woTransData = await fetchWithRetry(
              `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/work-order/api/work-order-tran/${woId}?selectedFields=%5B%22work_order_tran.*%22%2C%22assets.name%22%5D&joins=%5B%7B%22type%22%3A%22INNER%20JOIN%22%2C%22fromTable%22%3A%22work_order_tran%22%2C%22fromColumn%22%3A%22asset_id%22%2C%22toTable%22%3A%22assets%22%2C%22toColumn%22%3A%22id%22%7D%5D&orConditions=%5B%7B%22type%22%3A%22date_range_column%22%2C%22table%22%3A%22work_order_tran%22%2C%22date%22%3A%22${encodeURIComponent(startDate)}%22%2C%22startColumn%22%3A%22start_date%22%2C%22endColumn%22%3A%22end_date%22%7D%2C%7B%22type%22%3A%22date_range_column%22%2C%22table%22%3A%22work_order_tran%22%2C%22date%22%3A%22${encodeURIComponent(endDate)}%22%2C%22startColumn%22%3A%22start_date%22%2C%22endColumn%22%3A%22end_date%22%7D%2C%7B%22type%22%3A%22date_range%22%2C%22table%22%3A%22work_order_tran%22%2C%22column%22%3A%22start_date%22%2C%22start%22%3A%22${encodeURIComponent(startDate)}%22%2C%22end%22%3A%22${encodeURIComponent(endDate)}%22%7D%2C%7B%22type%22%3A%22date_range%22%2C%22table%22%3A%22work_order_tran%22%2C%22column%22%3A%22end_date%22%2C%22start%22%3A%22${encodeURIComponent(startDate)}%22%2C%22end%22%3A%22${encodeURIComponent(endDate)}%22%7D%5D`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            setWorkOrderTrans(woTransData || []);

            const workTypesData = await fetchWithRetry(
              `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/api/get-column/work_type/name?component_for=9&invoice_for={Demob}`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            setWorkTypes(workTypesData || []);
          } catch (woError) {
            console.warn("Failed to fetch work order data:", woError);
            setWorkOrderTrans([]);
            setWorkTypes([]);
          }
        }

        setLoading(false);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error("Failed to fetch data:", error);
          setError(error.message || "Failed to load invoice data. Please try again later.");
        }
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [id, token]);

  if (error) {
    const statusGate =
      typeof error === "string" &&
      (/does not have a report/i.test(error) ||
        /approved|sent to customer/i.test(error));
    return (
      <div>
        <NavLink to="/invoices">
          <button className="backbutton">Back To Invoices</button>
        </NavLink>
        <div style={{ textAlign: "center", marginTop: "50px", color: "red", padding: "20px" }}>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            {statusGate
              ? "Note: Invoices can only be viewed after they have been Approved or Sent to Customer."
              : String(error)}
          </p>
        </div>
      </div>
    );
  }

  if (loading || !allData || !company) {
    return (
      <div>
        <NavLink to="/invoices">
          <button className="backbutton">Back To Invoices</button>
        </NavLink>
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <p>Loading invoice data...</p>
        </div>
      </div>
    );
  }

  const formatDateTime = () => {
    const now = new Date();
    const date = now.toLocaleDateString('en-GB');
    const time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-');
    return `${date} / ${time}`;
  };

  const fileName = `${allData.invoice_master.doc_no || 'invoice'} / ${formatDateTime()}.pdf`;

  return (
    <>
      <NavLink to="/invoices">
        <button className="backbutton">Back To Invoices</button>
      </NavLink>
      <PDFViewer style={styles.viewer}>
        <InvoiceDocument
          allData={allData}
          company={company}
          workOrderTrans={workOrderTrans}
          workTypes={workTypes}
          fileName={fileName}
          units={units}
          assets={assets}
        />
      </PDFViewer>
    </>
  );
}